/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useContext, useEffect } from 'react';
import {
  TeamLogo,
  LoginWrapper,
} from '../../components';
import {
  Date,
  LoginLogo,
  Expiration,
  InfoWrapper,
  TitleWrapper,
  LoginLogoSpan,
  DateContainer,
  TitleComplete,
  TitlePurchase,
  LogoSuscription,
  TitleSuscription,
  PriceSuscription,
  SubtitleComplete,
  CheckoutComplete,
  DetailSuscription,
  ExpirationContainer,
  CompletePurchaseWrapper,
  ContainerLogoSuscription,
} from './styles'
import dayjs from 'dayjs';
import { LargeButton } from '../../components';
import { ARMcontext } from '../../utils/context/context';
import armcareLogo from '../../assets/icons/armcareIcon.png';
import { SignUp as SignUpClass } from '../../utils/api/';
import { useNavigate } from 'react-router-dom';

export default () => {
  const navigate = useNavigate();
  const SignUp = new SignUpClass();

  const [price, setPrice] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(true);
  const { dataCreateAccount, RemoveDataCreateAccount, HandleUser } = useContext(ARMcontext);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search) as any;
    SignUp.SuccessSubscription(params.get('email'), params.get('session_id')).then((response: any) => {
      setLoading(false);
      setPrice(response.finalPrice / 100);
    })
  }, [])

  const handleLogin = () => {
    let user: any = {
      role: 'org-admin',
      access_token: dataCreateAccount['access_token'],
      membership: { membershipStatus: 'OK' },
      data: {
        isFirstLogin: true,
        organization: {
          city: '',
          ...dataCreateAccount['organization']
        },
        ...dataCreateAccount['organization'],
      }
    }
    RemoveDataCreateAccount();
    HandleUser(user);
    navigate('/teams/card');
  }

  return (
    <LoginWrapper>
      <LoginLogo>
        <TeamLogo mWidth="200px" mHeight="40px" />
        <LoginLogoSpan>Measure. Monitor. Optimize</LoginLogoSpan>
      </LoginLogo>
      <CheckoutComplete>
        <TitleComplete>Thanks for your purchase</TitleComplete>
        <SubtitleComplete>Start using armcare to improve your team’s arm health</SubtitleComplete>
        <ExpirationContainer>
          <DateContainer>
            <Expiration>Subscription <br /> starting on:</Expiration>
            <Date>{dayjs().format('ll')}</Date>
          </DateContainer>
          {/* <RightArrow color="#7D8DA0" /> */}
          <DateContainer>
            {/* <Expiration>Subscription <br /> expire on:</Expiration>
            <Date>{dayjs().add(1, 'y').format('ll')}</Date> */}
          </DateContainer>
        </ExpirationContainer>
        <DetailSuscription>
          <TitlePurchase>Your purchase</TitlePurchase>
          <TitleWrapper>
            <ContainerLogoSuscription>
              <LogoSuscription src={armcareLogo} />
            </ContainerLogoSuscription>
            <InfoWrapper>
              <TitleSuscription>Coaches Portal Access</TitleSuscription>
              <PriceSuscription>$ {price}</PriceSuscription>
            </InfoWrapper>
          </TitleWrapper>
        </DetailSuscription>
        <CompletePurchaseWrapper>
          <LargeButton
            fullWidth
            lMargin="0"
            type="submit"
            fSize={'16px'}
            bradius={'8px'}
            rColor="#006BE1"
            disabled={loading}
            xMargin={'5vh 0 0;'}
            callback={handleLogin}
            colorDisabled={'#B3D7FF'}
            title="Start using armcare"
          />
        </CompletePurchaseWrapper>
      </CheckoutComplete>
    </LoginWrapper>
  );
}
